import { render, staticRenderFns } from "./Scene17.vue?vue&type=template&id=2478f296&scoped=true"
import script from "./Scene17.vue?vue&type=script&lang=js"
export * from "./Scene17.vue?vue&type=script&lang=js"
import style0 from "./Scene17.vue?vue&type=style&index=0&id=2478f296&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2478f296",
  null
  
)

export default component.exports